/**
 * API service for subscription management
 */

import { request } from '@/utils/request';

export interface SubscriptionLineItem {
  quantity: number;
  amount: number;
  currency: string;
  interval: string;
  description?: string | null;
}

export interface Subscription {
  subscription_id: string;
  display_name: string;
  description?: string;
  status: string;
  current_period_start?: number;
  current_period_end?: number;
  quantity?: number;
  amount?: number;
  currency?: string;
  interval?: string;
  line_items?: SubscriptionLineItem[];
  trial_start?: number;
  trial_end?: number;
  billing_cycle_anchor?: number;
  start_date?: number;
}

export interface SubscriptionStatus {
  customer_id?: string;
  customer_email?: string;
  has_payment_methods: boolean;
  subscriptions: Subscription[];
  message?: string;
}

export interface CreatePortalResponse {
  portal_url: string;
}

export interface CreateSetupSessionRequest {
  billing_preference: 'monthly' | 'yearly';
}

export interface CreateSetupSessionResponse {
  setup_url: string;
  session_id: string;
}

/**
 * Get current subscription status for the authenticated user
 */
export const getSubscriptionStatus = (): Promise<SubscriptionStatus> => {
  return request('subscription/status', {
    method: 'GET',
  });
};

/**
 * Create a Stripe Customer Portal session for subscription management
 */
export const createCustomerPortalSession = (): Promise<CreatePortalResponse> => {
  return request('subscription/portal', {
    method: 'POST',
    body: JSON.stringify({}),
  });
};

/**
 * Create a Stripe Checkout session in setup mode for payment method collection
 */
export const createSetupSession = (
  data: CreateSetupSessionRequest,
): Promise<CreateSetupSessionResponse> => {
  return request('subscription/setup', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};
